import { IpaChartProps } from "./IpaChart";
import { IpaRow } from "./Ipa";
import { miscClicks, miscConsonants, miscVowels } from "./ChartSymbols";

/** show misc IPA not on the main chart */
export function MiscChart(props: IpaChartProps) {
  return (
    <table>
      <tbody>
        <IpaRow title='Other Vowels' symbols={miscVowels} chartProps={props} />
        <IpaRow title='Other Consonants' symbols={miscConsonants} chartProps={props} />
        <IpaRow title='Click Segments' symbols={miscClicks} chartProps={props} />
      </tbody>
    </table>
  );
}
